import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";

const useFetchTableData = ({ queryKey, fetchFunc, params = {} }) => {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [queryKey, paginationModel.page, paginationModel.pageSize, params],
    queryFn: async () => {
      const page = paginationModel.page + 1; // Convert to 1-based for API
      const queryParams = new URLSearchParams({
        page: page.toString(),
        page_size: paginationModel.pageSize.toString(),
        ...params,
      });
      // Remove any undefined or null values
      Object.keys(queryParams).forEach(key => {
        if (queryParams[key] === undefined || queryParams[key] === null || queryParams[key] === '' || queryParams[key] === 'all') {
          delete queryParams[key];
        }
      });
      const res = await fetchFunc(queryParams);
      return res.data;
    },
    placeholderData: (previousData) => previousData,
  });
  return {
    data,
    isLoading,
    isError,
    error,
    refetch,
    paginationModel,
    setPaginationModel,
  };
};

export default useFetchTableData;
